// client/src/Utilities/config.js

// ---------------------------------------------------------
// 🌍 API Configuration Constants
// ---------------------------------------------------------

export const AUTH_PREFIX = '/auth';

/**
 * Resolves the base URL for the REST API.
 */
export function resolveBaseUrl() {
    // Check for Vite environment variables (import.meta.env)
    const viteApi = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_URL : undefined;
    // Check for Create React App (CRA) environment variables (process.env)
    const craApi = process.env.REACT_APP_API_BASE_URL;

    const envUrl = viteApi || craApi;
    const isProd = process.env.NODE_ENV === 'production';

    if (envUrl) {
        // Return explicit environment variable URL, cleaned of trailing slashes
        return envUrl.replace(/\/+$/, '');
    }

    if (isProd && typeof window !== 'undefined') {
        // Fallback for production: use the current origin + /api
        const fallback = `${window.location.origin}/api`.replace(/\/+$/, '');
        console.warn(`[Config] No explicit API base env; using production fallback = ${fallback}`);
        return fallback;
    }

    // Development default
    return 'http://localhost:5000/api';
}

export const BASE_URL = resolveBaseUrl();
console.log('[Config] Final BASE_URL =', BASE_URL);

// Export the path to the refresh endpoint for external use
export const REFRESH_URL = `${BASE_URL}${AUTH_PREFIX}/refresh-token`;

// ---------------------------------------------------------
// 🔌 Socket Configuration Constants (NEW SECTION)
// ---------------------------------------------------------

/**
 * Resolves the base URL for the Socket.IO server.
 * Typically, this is the origin (protocol + domain:port) of the API server.
 */
function resolveSocketUrl() {
    // Check for explicit Socket URL environment variables
    const viteSocket = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_SOCKET_URL : undefined;
    const craSocket = process.env.REACT_APP_SOCKET_URL;
    const envSocket = viteSocket || craSocket;

    // Check for API URL environment variables (as a fallback)
    const viteApi = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_URL : undefined;
    const craApi = process.env.REACT_APP_API_BASE_URL;
    const envApi = viteApi || craApi;

    const isProd = process.env.NODE_ENV === 'production';

    if (envSocket) return envSocket.replace(/\/+$/, '');

    //Fallback 1: If API URL is set, use its origin (e.g., if API is https://api.site.com/api, use https://api.site.com)
    if (envApi) {
        try {
            const url = new URL(envApi);
            return url.origin.replace(/\/+$/, '');
        } catch {
        }
    }

    // Fallback 2: Production fallback is the current origin
    if (isProd && typeof window !== 'undefined') {
        return window.location.origin.replace(/\/+$/, '');
    }

    // Dev fallback (typically same as the API origin)
    return 'http://localhost:5000';
}

export const SOCKET_URL = resolveSocketUrl();
console.log('[Config] Final SOCKET_URL =', SOCKET_URL);